/**
 * 移动端搜索图标
 */
const MobSearchIcon = ({ width = 16, height = 16, color = '#000' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none">
      <g opacity="0.3">
        <path
          d="M14.8291 14.7715C14.8911 14.7096 14.9402 14.6361 14.9737 14.5552C15.0072 14.4743 15.0245 14.3876 15.0245 14.3C15.0245 14.2124 15.0072 14.1257 14.9737 14.0448C14.9402 13.9639 14.8911 13.8904 14.8291 13.8285L12.4725 11.4718C12.3474 11.3467 12.1779 11.2764 12.001 11.2764C11.8242 11.2763 11.6545 11.3465 11.5295 11.4715C11.4044 11.5965 11.334 11.7661 11.334 11.9429C11.3339 12.1198 11.4041 12.2894 11.5291 12.4145L13.8865 14.7712C14.0115 14.8961 14.181 14.9664 14.3578 14.9664C14.5346 14.9664 14.7041 14.8961 14.8291 14.7712V14.7715Z"
          fill={color}
        />
        <path
          d="M8 12.6667C5.42267 12.6667 3.33333 10.5773 3.33333 8C3.33333 5.42267 5.42267 3.33333 8 3.33333C10.5773 3.33333 12.6667 5.42267 12.6667 8C12.6667 10.5773 10.5773 12.6667 8 12.6667ZM8 14C11.3137 14 14 11.3137 14 8C14 4.68633 11.3137 2 8 2C4.68633 2 2 4.68633 2 8C2 11.3137 4.68633 14 8 14Z"
          fill={color}
        />
      </g>
    </svg>
  )
}

export default MobSearchIcon
